var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"c-button"},'div',_vm.$attrs,false),_vm.$listeners),[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.Text))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/image/button/add.svg")}})])
}]

export { render, staticRenderFns }